import { shiftHue } from "./shiftHue";
import { shiftLightness } from "./shiftLightness";

/**
 * Generates confidence level colors based on the primary color
 * @param {string} primaryColor - The primary color in OKLCH format or CSS variable
 * @param {boolean} isDarkTheme - Whether this is a dark theme
 * @returns {Object} Object containing all confidence color definitions
 */
export function generateConfidenceColors(primaryColor, contentColor, isDarkTheme = false) {
  // Check if primaryColor is a CSS variable reference
  const isVariable = primaryColor.includes('var(--');
  
  if (isVariable) {
    // For CSS variable themes, use opacity-based approach
    return {
      "confidence-learned": "var(--color-primary) / 1",
      "confidence-learned-bg": "var(--color-primary) / 0.3",
      "confidence-recognised": "var(--color-primary) / 0.9",
      "confidence-recognised-bg": "var(--color-primary) / 0.25",
      "confidence-familiar": "var(--color-primary) / 0.8",
      "confidence-familiar-bg": "var(--color-primary) / 0.25",
      "confidence-new": "var(--color-primary) / 0.7",
      "confidence-new-bg": "var(--color-primary) / 0.15"
    };
  }
  // Define opacity values for backgrounds
  const opacities = isDarkTheme ? {
    learned: 0.4,
    familiar: 0.3,
    recognised: 0.15,
    new: 0
  } : {
    learned: 0.4,
    familiar: 0.2,
    recognised: 0.1,
    new: 0.00
  };

  // Define hue shifts for each confidence level
  const hueShifts = {
    learned: 0,      // Primary color
    familiar: 0,   // Shift towards purple
    recognised: 0, // Further shift
    new: 0         // Shift towards yellow/orange
  };

  // Define lightness shifts (darker in light mode, lighter in dark mode)
  const lightnessShifts = {
    learned: isDarkTheme ? 50 : -30,
    familiar: isDarkTheme ? 50 : -30,    // Extreme shift to test
    recognised: isDarkTheme ? 70 : -40,  // More extreme shift
    new: isDarkTheme ? 90 : -50         // Most extreme shift
  };

  // Apply both hue and lightness shifts
  // const learnedColor = shiftLightness(shiftHue(primaryColor, hueShifts.learned), lightnessShifts.learned);
  const learnedColorBg = shiftHue(primaryColor, hueShifts.learned);

  // const familiarColor = shiftLightness(shiftHue(primaryColor, hueShifts.familiar), lightnessShifts.familiar);
  const familiarColorBg = shiftHue(primaryColor, hueShifts.familiar);

  // const recognisedColor = shiftLightness(shiftHue(primaryColor, hueShifts.recognised), lightnessShifts.recognised);
  const recognisedColorBg = shiftHue(primaryColor, hueShifts.recognised);

  // const newColor = shiftLightness(shiftHue(primaryColor, hueShifts.new), lightnessShifts.new);
  const newColorBg = shiftHue(primaryColor, hueShifts.new);

  const learnedColor = contentColor
  const familiarColor = contentColor
  const recognisedColor = contentColor
  const newColor = contentColor

  return {
    "confidence-learned": learnedColor,
    "confidence-learned-bg": `${learnedColorBg} / ${opacities.learned}`,
    
    "confidence-familiar": familiarColor,
    "confidence-familiar-bg": `${familiarColorBg} / ${opacities.familiar}`,
    
    "confidence-recognised": recognisedColor,
    "confidence-recognised-bg": `${recognisedColorBg} / ${opacities.recognised}`,
    
    "confidence-new": newColor,
    "confidence-new-bg": `${newColorBg} / ${opacities.new}`
  };
}
